import { useHistory } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';
import {matchPath,  useLocation } from 'react-router-dom';

const ErrorBoundaryWrapper = ({ children }) => {
    const history = useHistory();
    const location = useLocation();
    const dialogPaths = [
        '/persons','/names','/warrants','/addresses','/places','/properties',
        '/search/bulletin','/search/agencies','/search/credentials','/search/employees',
        '/search/images','/search/phone-numbers','/search/vehicle-towings','/search/zones'];
    
    const isDialog = dialogPaths.some(path =>
        matchPath(location.pathname, { path, exact: true })
    );

    const handleError = () => {
        if (!isDialog) {
            history.go(-1);
          }
          else{
            history.go(0);
          }        
    };
  
    return (
      <ErrorBoundary onError={handleError} location={location} isDialog={isDialog}>
        {children}
      </ErrorBoundary>
    );
  };
  
  export default ErrorBoundaryWrapper;